module.exports = __webpack_public_path__ + "media/images/icons/brushstroke-1e154640708fa91555beb85b630e6dee.svg";